<button *ngFor="let tag of tagsList" class="tag-button" type="button" (click)="checkTab(tag)">
  <a class="global-tag" [ngClass]="{ 'global-tag-clicked': tag.isActive }" [tabIndex]="0">
    <span class="text" [appLangValue]="{ ua: tag.nameUa, en: tag.name }"></span>
    <div [ngClass]="{ 'global-tag-close-icon': tag.isActive }"></div>
  </a>
</button>
